import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 53%;
  height: 673px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${({ theme }) => theme.colors.greenMain};
  border-radius: 50%;

  &:before {
    content: '\\e900';
    font-family: Icomoon;
    font-size: 22px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Title = styled(typography.H1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const SubTitle = styled(typography.P1RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;
